/**
 * Generated bundle index. Do not edit.
 */
export * from './main';
export { DIALOG_DIRECTIVES as ɵa } from './dialog.module';
export { DialogContainerDirective as ɵh } from './dialog/dialog-container.directive';
export { DialogContainerService as ɵb } from './dialog/dialog-container.service';
export { SHARED_DIRECTIVES as ɵi, SharedModule as ɵj } from './shared.module';
export { DragResizeService as ɵc } from './window/drag-resize.service';
export { DraggableDirective as ɵf } from './window/draggable.directive';
export { NavigationService as ɵd } from './window/navigation.service';
export { WindowContainerDirective as ɵk } from './window/window-container.directive';
export { WindowContainerService as ɵg } from './window/window-container.service';
export { ResizeHandleDirective as ɵe } from './window/window-resize-handle.directive';



//////////////////
// WEBPACK FOOTER
// C:/spro/Workspaces/VisualCode/Ecoltex2/node_modules/@progress/kendo-angular-dialog/dist/es/index.js
// module id = ../../../../@progress/kendo-angular-dialog/dist/es/index.js
// module chunks = vendor